import { IonHeader, IonImg, IonIcon, IonMenuToggle } from '@ionic/react'
import { BaseButton, IsInView, LanguageSelector } from 'components'
import React, { useCallback, useContext, useState } from 'react'
import './header.scss'
import base_logo from 'theme/images/logo.svg'
import { icon_campus, icon_profile } from 'icons'
import { Link } from 'react-router-dom'
import three_bars from 'theme/images/three-bars.svg'
import { IHeaderProps } from './header-props.interface'
import { routeService } from 'services'
import { useTranslation } from 'react-i18next'
import { Fade as Hamburger } from 'hamburger-react'
import { authContext } from 'contexts'

const Header: React.FC<IHeaderProps> = ({ isAuthenticated, menuMobileOpen, setMenuMobileOpen }) => {
  const { t } = useTranslation()
  const auth = useContext(authContext)

  const btnComponent = isAuthenticated ? (
    <>
      <IonMenuToggle autoHide={false}>
        <BaseButton label={auth?.user?.nome.charAt(0) + '' + auth?.user?.cognome.charAt(0)} icon={icon_profile} />
      </IonMenuToggle>
    </>
  ) : (
    <Link to={routeService.generateRoutePath('/login')}>
      <BaseButton label={t('login')} icon={icon_profile} />
    </Link>
  )
  const headerLinks = (
    <>
      <Link to={routeService.generateRoutePath('/about')} className="header-link" onClick={() => setMenuMobileOpen(false)}>
        <IonIcon icon={icon_campus} className="header-icon" />
        {t('about_us')}
      </Link>
    </>
  )
  return (
    <IonHeader className={'edisu-header mobile-open'}>
      <Link to={routeService.generateRoutePath('/')}>
        <IonImg src={base_logo} className="logo-header" />
      </Link>

      <div className={'right-container secondary-color'}>
        {headerLinks}
        <LanguageSelector></LanguageSelector>
        {btnComponent}
      </div>
      <IsInView param="header" className={'bars-container'}>
        <img src={three_bars} alt="" />
        <div className={'menu-mobile' + (!menuMobileOpen ? ' mobile-hide' : '')}>{headerLinks}</div>
      </IsInView>

      <div className="mobile-right-container">
        {btnComponent}
        <LanguageSelector></LanguageSelector>

        <Hamburger toggled={menuMobileOpen} toggle={setMenuMobileOpen} size={24} />
      </div>
    </IonHeader>
  )
}

export default Header
